/* Coshi — scroll reveals for stock template content.

   Dawn ships its own version of this and it is what made text vanish on the
   shop page: it pre-hides with CSS at opacity .01 and depends on an
   IntersectionObserver callback to undo it, so any missed callback leaves copy
   permanently invisible. That mechanism is force-disabled in meta-tags.liquid.
   This is its replacement, built so the same failure cannot happen:

     1. The hidden state is applied by JS, never by CSS. No script, no
        exception, no IntersectionObserver support -> nothing is ever hidden.
     2. Elements already on screen are never touched. Only content the visitor
        has not reached yet can animate in.
     3. Two safety nets force-reveal anything still hidden while inside the
        viewport: a 400ms interval for the first 12 seconds, and a permanent
        rAF-throttled scroll sweep. Worst case is a late reveal, never a
        permanent one.
     4. load, pageshow (bfcache) and resize all re-sweep.

   Sections with bespoke choreography in coshi-gsap.js are skipped, so a block
   is never animated by two systems at once. */
(function () {
  'use strict';

  var OWNED = '.ci, .cl, .cq, .ca, .tk, .ccn, .ft, .cs-bg, .cn';

  var GROUPS = [
    { sel: '.collection-hero__title, .main-page-title, .title, .rich-text__heading', kind: 'up' },
    { sel: '.collection-hero__description, .rich-text__text, .rte > p, .rte > ul, .rte > ol, .rte > h2, .rte > h3', kind: 'up' },
    { sel: '#product-grid .grid__item, .collection .grid__item', kind: 'alt' },
    { sel: '.rich-text__buttons, .cart__ctas, .cart__footer > *', kind: 'up' },
    { sel: '.product__media-wrapper', kind: 'left' },
    { sel: '.product__info-container > *', kind: 'right' },
    { sel: '.cart-item', kind: 'up' },
    { sel: '.contact .field, .contact button, .contact h2', kind: 'up' }
  ];

  function start() {
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    } catch (e) {}
    if (!('IntersectionObserver' in window)) return;   /* rule 1: hide nothing */

    var main = document.getElementById('MainContent');
    if (!main) return;

    var items = [];
    var seen = [];

    GROUPS.forEach(function (g) {
      var list;
      try { list = main.querySelectorAll(g.sel); } catch (e) { return; }
      Array.prototype.forEach.call(list, function (el, i) {
        if (seen.indexOf(el) > -1) return;
        if (el.closest && el.closest(OWNED)) return;      /* bespoke motion owns it */
        if (!el.getBoundingClientRect) return;
        var r = el.getBoundingClientRect();
        if (r.height < 6 && r.width < 6) return;
        /* rule 2: anything already on screen is left exactly as it is */
        if (r.top < window.innerHeight * 0.92) return;
        seen.push(el);
        var cls = 'cs-rv';
        if (g.kind === 'left') cls += ' cs-rv--l';
        else if (g.kind === 'right') cls += ' cs-rv--r';
        else if (g.kind === 'alt') cls += (i % 2 ? ' cs-rv--r' : ' cs-rv--l');
        el.className += ' ' + cls;
        el.style.transitionDelay = Math.min(i % 4, 3) * 80 + 'ms';
        items.push(el);
      });
    });

    if (!items.length) return;

    function show(el) {
      if (!el || el.classList.contains('is-in')) return;
      el.classList.add('is-in');
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { show(en.target); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });

    items.forEach(function (el) { io.observe(el); });

    /* rule 3: the safety nets. Anything hidden while it is on screen gets
       revealed regardless of what the observer did. */
    function sweep() {
      for (var i = items.length - 1; i >= 0; i--) {
        var el = items[i];
        if (el.classList.contains('is-in')) { items.splice(i, 1); continue; }
        var r = el.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) { show(el); io.unobserve(el); items.splice(i, 1); }
      }
    }

    var ticks = 0;
    var iv = setInterval(function () {
      sweep();
      if (++ticks > 30 || !items.length) clearInterval(iv);   /* 12s */
    }, 400);

    var pending = false;
    window.addEventListener('scroll', function () {
      if (pending || !items.length) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; sweep(); });
    }, { passive: true });

    window.addEventListener('load', sweep);
    window.addEventListener('resize', sweep);
    window.addEventListener('pageshow', sweep);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else { start(); }
})();
